(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('card-product')) {
    customElements.define(
      'card-product',
      class CardProduct extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.BLANK = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';

          this.swatches = this.querySelectorAll('.card-product__swatch');
          if (this.swatches.length) this.initSwatches();

          this.hoverPicture = this.querySelector('.data-attributes-trigger--hover');
          if (this.hoverPicture) {
            this.addEventListener('mouseenter', () => this.activatePicture(this.hoverPicture));
            this.addEventListener('mouseleave', () => this.disablePicture(this.hoverPicture));
          }

          this.slider = this.querySelector('.card-product__images--carousel');
          if (this.slider) {
            this.handleSliderImages();
          }

          this.vtoLink = this.querySelector('.vto__link');
          if (this.vtoLink) this.handleVtoLink();
        }

        initSwatches() {
          const swatchesWrapper = this.querySelector('.card-product__swatches');
          const allSwatchesPictures = this.querySelectorAll('.data-attributes-trigger--swatch');
          swatchesWrapper?.addEventListener('mouseleave', () => {
            allSwatchesPictures.forEach((picture) => this.disablePicture(picture));
          });

          this.swatches.forEach((swatch) => {
            swatch.addEventListener('mouseenter', () => {
              allSwatchesPictures.forEach((picture) => this.disablePicture(picture));

              const picture = this.querySelector(`#${swatch.dataset.imageToShow}`);
              this.activatePicture(picture);
            });
          });
        }

        handleSliderImages() {
          const slides = this.slider.querySelectorAll('img');

          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  const picture = entry.target.closest('picture');
                  this.activatePicture(picture);
                }
              });
            },
            { root: this.slider, threshold: 0 }
          );

          slides.forEach((slide) => observer.observe(slide));
        }

        activatePicture(picture) {
          picture.querySelectorAll('source[data-srcset]').forEach((source) => {
            source.srcset = source.dataset.srcset;
            source.removeAttribute('data-srcset');
          });

          const img = picture.querySelector('img[data-src]');
          if (!img) return;

          if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset;
            img.removeAttribute('data-srcset');
          }
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          picture.classList.add('active');
        }

        disablePicture(picture) {
          picture.classList.remove('active');

          picture.querySelectorAll('source[srcset]').forEach((source) => {
            source.dataset.srcset = source.srcset;
            source.removeAttribute('srcset');
          });

          const img = picture.querySelector('img');
          if (!img) return;

          if (img.srcset) {
            img.dataset.srcset = img.srcset;
            img.srcset = '';
          }
          if (img.src && !img.src.startsWith('data:')) {
            img.dataset.src = img.src;
          }
          img.src = this.BLANK;
        }

        handleVtoLink() {
          const productId = this.vtoLink.dataset.productId;
          const vtoReference = this.vtoLink.dataset.vtoReference;
          if (!productId || !vtoReference) return;

          const productOptions = JSON.parse(this.querySelector(`#vtoParams${productId}`).textContent);

          const params = {
            apiKey: 'tYzzTYcS8uP7Atn0DBIBfToCz2PTXSlWlJhVDuqj',
            popupIntegration: {
              centeredHorizontal: true,
              centeredVertical: true,
              width: '640px',
              height: '480px',
            },
            carousel: productOptions,
          };

          this.vtoLink.addEventListener('click', () => {
            window.fitmixInstance = FitMix.createWidget(`fitmix-container-${productId}`, params);
            setTimeout(() => {
              window.fitmixInstance.setFrame(vtoReference);
              window.fitmixInstance.startVto('live');
            }, 500);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["depict-patched-card-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('card-product')) {
    customElements.define(
      'card-product',
      class CardProduct extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.BLANK = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';

          this.swatches = this.querySelectorAll('.card-product__swatch');
          if (this.swatches.length) this.initSwatches();

          this.hoverPicture = this.querySelector('.data-attributes-trigger--hover');
          if (this.hoverPicture) {
            this.addEventListener('mouseenter', () => this.activatePicture(this.hoverPicture));
            this.addEventListener('mouseleave', () => this.disablePicture(this.hoverPicture));
          }

          this.slider = this.querySelector('.card-product__images--carousel');
          if (this.slider) {
            this.handleSliderImages();
          }

          this.vtoLink = this.querySelector('.vto__link');
          if (this.vtoLink) this.handleVtoLink();
        }

        initSwatches() {
          const swatchesWrapper = this.querySelector('.card-product__swatches');
          const allSwatchesPictures = this.querySelectorAll('.data-attributes-trigger--swatch');
          swatchesWrapper?.addEventListener('mouseleave', () => {
            allSwatchesPictures.forEach((picture) => this.disablePicture(picture));
          });

          this.swatches.forEach((swatch) => {
            swatch.addEventListener('mouseenter', () => {
              allSwatchesPictures.forEach((picture) => this.disablePicture(picture));

              const picture = this.querySelector(`#${swatch.dataset.imageToShow}`);
              this.activatePicture(picture);
            });
          });
        }

        handleSliderImages() {
          const slides = this.slider.querySelectorAll('img');

          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  const picture = entry.target.closest('picture');
                  this.activatePicture(picture);
                }
              });
            },
            { root: this.slider, threshold: 0 }
          );

          slides.forEach((slide) => observer.observe(slide));
        }

        activatePicture(picture) {
          picture.querySelectorAll('source[data-srcset]').forEach((source) => {
            source.srcset = source.dataset.srcset;
            source.removeAttribute('data-srcset');
          });

          const img = picture.querySelector('img[data-src]');
          if (!img) return;

          if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset;
            img.removeAttribute('data-srcset');
          }
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          picture.classList.add('active');
        }

        disablePicture(picture) {
          picture.classList.remove('active');

          picture.querySelectorAll('source[srcset]').forEach((source) => {
            source.dataset.srcset = source.srcset;
            source.removeAttribute('srcset');
          });

          const img = picture.querySelector('img');
          if (!img) return;

          if (img.srcset) {
            img.dataset.srcset = img.srcset;
            img.srcset = '';
          }
          if (img.src && !img.src.startsWith('data:')) {
            img.dataset.src = img.src;
          }
          img.src = this.BLANK;
        }

        handleVtoLink() {
          const productId = this.vtoLink.dataset.productId;
          const vtoReference = this.vtoLink.dataset.vtoReference;
          if (!productId || !vtoReference) return;

          const productOptions = JSON.parse(this.querySelector(`#vtoParams${productId}`).textContent);

          const params = {
            apiKey: 'tYzzTYcS8uP7Atn0DBIBfToCz2PTXSlWlJhVDuqj',
            popupIntegration: {
              centeredHorizontal: true,
              centeredVertical: true,
              width: '640px',
              height: '480px',
            },
            carousel: productOptions,
          };

          this.vtoLink.addEventListener('click', () => {
            window.fitmixInstance = FitMix.createWidget(`fitmix-container-${productId}`, params);
            setTimeout(() => {
              window.fitmixInstance.setFrame(vtoReference);
              window.fitmixInstance.startVto('live');
            }, 500);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-information-content"] && !Shopify.designMode) return;
  try {
    window.onload = function () {
    window.fitmixInstance = FitMix.createWidget('fitmix-container', window.fittingboxParams);
  };

  window.addEventListener('load', function () {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('show_vto') === 'true') {
      setTimeout(function () {
        const vtoLink = document.querySelector('.vto__link');
        if (vtoLink) vtoLink.click();
        window.history.replaceState(null, '', window.location.pathname);
      }, 500);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('[data-read-more-btn]').forEach((btn) => {
      const block = btn.previousElementSibling;
      block.dataset.collapsed = '';

      btn.addEventListener('click', () => {
        const isCollapsed = 'collapsed' in block.dataset;
        if (isCollapsed) {
          delete block.dataset.collapsed;
          btn.setAttribute('aria-expanded', 'true');
          btn.querySelector('[data-read-more-label]').hidden = true;
          btn.querySelector('[data-read-less-label]').hidden = false;
        } else {
          block.dataset.collapsed = '';
          btn.setAttribute('aria-expanded', 'false');
          btn.querySelector('[data-read-more-label]').hidden = false;
          btn.querySelector('[data-read-less-label]').hidden = true;
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
